import { Get } from "./helpers";

export const GetTemplates = async (channel: number, token: string): Promise<any> => {
	return Get(`/v3/admin/events/templates/${channel}`, token, {}, true)
		.then(async res => {
			return await res.json();
		});
};
